import { Component, OnInit } from '@angular/core';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { EmpresaGrupoService } from '../../../shared/services/apis/usuario/empresa-grupo.service';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { EmpresaGrupoResponse } from '../../../shared/services/responses/usuario/empresa-grupo.response';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';
import { EmpresaGrupoRequest } from '../../../shared/services/requests/usuario/empresa-grupo.request';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { EmpresaService } from '../../../shared/services/apis/usuario/empresa.service';
import { ListaEmpresaResponse } from '../../../shared/services/responses/usuario/lista-empresa.response';
import { CnpjPipe } from '../../../shared/pipes/cnpj.pipe';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { EmpresaGrupoStruct } from '../../../shared/services/structs/usuario/empresa-grupo.struct';
import { EmpresaStruct } from '../../../shared/services/structs/usuario/empresa.struct';
import { ListaEmpresaAdminService } from '../../../shared/services/apis/usuario/lista-empresa-admin.service';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { Empresa } from '../../../shared/services/models/usuario/empresa.model';
import { ListaEmpresaAdminResponse } from '../../../shared/services/responses/usuario/lista-empresa-admin.response';

@Component({
  selector: 'app-empresa-grupo-cadastro',
  templateUrl: './empresa-grupo-cadastro.component.html',
  styleUrls: ['./empresa-grupo-cadastro.component.css'],
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MenuComponent,
    MatFormFieldModule,
    FormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    RouterModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatSelectModule,
    CnpjPipe,
    MatTableModule,
    LoadingBoxComponent,
    EmptyListComponent,
    SelectPesquisavelComponent,
  ],
})
export class EmpresaGrupoCadastroComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;
  private readonly cnpjPipe = new CnpjPipe();

  constructor(
    private formBuilder: FormBuilder,
    private empresaGrupoService: EmpresaGrupoService,
    private listaEmpresaAdminService: ListaEmpresaAdminService,
    private empresaService: EmpresaService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.moduloEnum = ModuloEnum.Implantacao;
    this.funcionalidadeEnum = FuncionalidadeEnum.Implantacao_GrupoEmpresa;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public idEmpresaPrincipal: number | null = null;

  public idEmpresaGrupo: number | null = null;
  public _empresaGrupoResponse: EmpresaGrupoResponse;
  public empresasResponse: ListaEmpresaResponse;

  public _listaEmpresaResponse: ListaEmpresaResponse | undefined;
  public displayedColumns: string[] = ['nomeEmpresa', 'cnpj', 'matrizFilial', 'status'];
  public _dataSource = new MatTableDataSource<Empresa>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;

  async ngOnInit(): Promise<void> {
    if (this.activatedRoute.snapshot.params['id']) {
      this.idEmpresaGrupo = parseInt(this.activatedRoute.snapshot.params['id'] ?? '');
    }

    this.model = this.formBuilder.group({
      nomeEmpresaGrupo: new FormControl({ value: '', disabled: false }, [Validators.required, requiredTrim]),
      idEmpresaPrincipal: new FormControl({ value: '', disabled: false }, [Validators.required]),
    });

    await this.lookupEmpresa();

    if (this.idEmpresaGrupo) {
      await this.popularDados();
      this.pesquisar();
    }
  }

  async lookupEmpresa(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.empresaService.getAll(this.idEmpresaGrupo ? false : true).subscribe({
        next: (listaEmpresaResponse: ListaEmpresaResponse) => {
          if (listaEmpresaResponse.isError) {
            this.alertService.show('Erro', listaEmpresaResponse.errorDescription, AlertType.error);
            reject(listaEmpresaResponse.errorDescription);
            return;
          }

          this.empresasResponse = listaEmpresaResponse;
          resolve();
        },
        error: (error: any) => {
          this.alertService.show('Erro inesperado', error.message, AlertType.error);
          reject(error);
        },
      });
    });
  }

  async popularDados(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.empresaGrupoService.ObterPorId(this.idEmpresaGrupo ?? 0).subscribe({
        next: (empresaGrupoResponse: EmpresaGrupoResponse) => {
          if (empresaGrupoResponse.isError) {
            this.alertService.show('Erro', empresaGrupoResponse.errorDescription, AlertType.error);
            reject(empresaGrupoResponse.errorDescription);
            return;
          }

          this.model.get('nomeEmpresaGrupo')?.setValue(empresaGrupoResponse.empresaGrupo.nomeEmpresaGrupo);
          this.model
            .get('idEmpresaPrincipal')
            ?.setValue(empresaGrupoResponse.empresaGrupo.empresaPrincipal!.idEmpresa);

          this._empresaGrupoResponse = empresaGrupoResponse;
          this.model.get('idEmpresaPrincipal')?.disable();
          this.idEmpresaPrincipal = empresaGrupoResponse.empresaGrupo.empresaPrincipal!.idEmpresa;

          const empresaPrincipal = empresaGrupoResponse.empresaGrupo.empresaPrincipal;
          if (empresaPrincipal) {
            const exists = this.empresasResponse.listaEmpresa.some(
              empresa => empresa.idEmpresa === empresaPrincipal.idEmpresa
            );
            if (!exists) {
              this.empresasResponse.listaEmpresa.push(empresaPrincipal as any);
            }
          }

          resolve();
        },
        error: (error: any) => {
          this.alertService.show('Erro inesperado', error.message, AlertType.error);
          reject(error);
        },
      });
    });
  }

  submit(): void {
    if (this._isLoading || this.model.invalid) {
      return;
    }

    const empresaGrupoRequest: EmpresaGrupoRequest = new EmpresaGrupoRequest();

    empresaGrupoRequest.empresaGrupo = new EmpresaGrupoStruct();

    empresaGrupoRequest.empresaGrupo.idEmpresaGrupo = this.idEmpresaGrupo;
    empresaGrupoRequest.empresaGrupo.nomeEmpresaGrupo = this.model.get('nomeEmpresaGrupo')?.value;

    // Initialize the object to avoid "cannot read properties of undefined"
    empresaGrupoRequest.empresaGrupo.empresaPrincipal = {
      idEmpresa: this.model.get('idEmpresaPrincipal')?.value,
      nomeEmpresa: '',
      cnpj: '',
    } as any;

    if (!this.idEmpresaGrupo) {
      this.novo(empresaGrupoRequest);
    } else {
      this.alterar(empresaGrupoRequest);
    }
  }

  private novo(empresaGrupoRequest: EmpresaGrupoRequest): void {
    this._isLoading = true;
    this.empresaGrupoService.incluir(empresaGrupoRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Grupo de empresas cadastrada com sucesso!', AlertType.success);
        this.router.navigate(['/implantacao/empresa-grupo']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  private alterar(empresaGrupoRequest: EmpresaGrupoRequest): void {
    this._isLoading = true;
    this.empresaGrupoService.alterar(this.idEmpresaGrupo ?? 0, empresaGrupoRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Grupo de empresas alterada com sucesso!', AlertType.success);
        this.router.navigate(['/implantacao/empresa-grupo']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  private pesquisar(): void {
    if (this._isLoading === true || this.idEmpresaGrupo === null) {
      return;
    }

    this._isLoading = true;

    this.empresaGrupoService.getEmpresasPorGrupo(this.idEmpresaGrupo).subscribe({
      next: (response: ListaEmpresaAdminResponse) => {
        this._isLoading = false;

        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this._dataSource.data = response.list;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  onSearchEmpresa(query: string): void {
    const cleanQuery = query?.trim();

    if (!cleanQuery || cleanQuery.length < 3) {
      return;
    }

    // Preserva letras (CNPJ alfanumérico) — remove apenas separadores de formatação
    const semSeparadores = cleanQuery.replace(/[.\-\/\s]/g, '');
    // Basic heuristic: if it has 11 or more chars, treat as CNPJ (or potentially CPF if supported later)
    const looksLikeCnpj = semSeparadores.length >= 11;

    const cnpj = looksLikeCnpj ? semSeparadores : null;
    const razaoSocial = looksLikeCnpj ? null : cleanQuery;

    this.empresaService.get(cnpj, razaoSocial, null).subscribe({
      next: (response: ListaEmpresaResponse) => {
        if (!response.isError) {
          if (!this.empresasResponse) {
            this.empresasResponse = response;
          } else {
            this.empresasResponse.listaEmpresa = response.listaEmpresa;
          }
        }
      },
      error: err => {
        console.error('Error searching empresa', err);
      },
    });
  }

  public get idEmpresaPrincipalControl(): FormControl {
    return this.model.get('idEmpresaPrincipal') as FormControl;
  }

  public get empresasParaSelect(): any[] {
    return (this.empresasResponse?.listaEmpresa || []).map(empresa => ({
      ...empresa,
      cnpjFormatado: this.cnpjPipe.transform(empresa.cnpj),
    }));
  }
}
